import { render } from "./receipt-processor.vue?vue&type=template&id=210adbdc&scoped=true"
import script from "./receipt-processor.vue?vue&type=script&lang=js"
export * from "./receipt-processor.vue?vue&type=script&lang=js"

import "./receipt-processor.vue?vue&type=style&index=0&id=210adbdc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210adbdc"]])

export default __exports__